import { createFileRoute } from "@tanstack/react-router";
import TeamsPage from "@/pages/teams/page";

export const Route = createFileRoute("/_pathlessLayout/teams")({
    component: TeamsPage,
});
